import { FaFire, FaGraduationCap, FaBriefcase, FaInfoCircle, FaTools, FaRegFolder, FaExternalLinkAlt, FaFileDownload } from "react-icons/fa";
import { Link } from "react-router-dom";
import SideBarIcon from "./SidebarIcon";

const SideBar = () => {
  return (
    <div className="fixed top-0 left-0 h-screen w-16 z-10 flex flex-col bg-white dark:bg-gray-900 shadow-lg">
      <Link to="/">
        <SideBarIcon icon={<FaFire size="28" />} text="Homepage" />
      </Link>
      <hr className="sidebar-hr" />
      <Link to="/about">
        <SideBarIcon icon={<FaInfoCircle size="32" />} text="About me" />
      </Link>
      <Link to="/work">
        <SideBarIcon icon={<FaBriefcase size="20" />} text="Work Experience" />
      </Link>
      <Link to="/education">
        <SideBarIcon icon={<FaGraduationCap size="20" />} text="Education" />
      </Link>
      <Link to="/skills">
        <SideBarIcon icon={<FaTools size="20" />} text="Skills" />
      </Link>
      <Link to="/portfolio">
        <SideBarIcon icon={<FaRegFolder size="22" />} text="Portfolio" />
      </Link>
      <hr className="sidebar-hr" />
      <Link to="/socials">
        <SideBarIcon icon={<FaExternalLinkAlt size="22" />} text="Socials" />
      </Link>
      <hr className="sidebar-hr w-3/4 absolute bottom-16" />
      <Link to="assets/files/CV_2022.pdf" target="_blank" download className="bottom-0 absolute w-full">
        <SideBarIcon icon={<FaFileDownload size="22" />} text="Download CV" />
      </Link>
    </div>
  );
};

export default SideBar;
